var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"videoPlayer",attrs:{"src":_vm.videoUrl,"allow":"autoplay; fullscreen","allowfullscreen":"","height":"100%","id":"iframe","mozallowfullscreen":"","frameBorder":"0","webkitallowfullscreen":"","width":"100%","title":"exercise video"}})
}
var staticRenderFns = []

export { render, staticRenderFns }